var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteLoans = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/loans") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/loans",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/loans"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.1465, 5.6805)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0675843,7.92 C19.8489783,7.92 21.285,6.48201117 21.285,4.7025 C21.285,2.92298883 19.8308008,1.485 18.0675843,1.485 C16.3043678,1.485 14.8501686,2.92298883 14.8501686,4.7025 C14.8319911,6.48201117 16.2861903,7.92 18.0675843,7.92 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6525,6.435 C11.4339407,6.435 12.87,4.99701117 12.87,3.2175 C12.87,1.43798883 11.4157627,0 9.6525,0 C7.88923729,0 6.435,1.43798883 6.435,3.2175 C6.435,4.99701117 7.88923729,6.435 9.6525,6.435 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.475,11.385 L0.749471831,11.385 C0.331161972,11.385 0,11.7169412 0,12.1362353 L0,18.0587647 C0,18.4780588 0.331161972,18.81 0.749471831,18.81 L2.475,18.81 L2.475,11.385 L2.475,11.385 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5147385,10.4250656 C24.0836657,8.93535772 21.751547,8.93535772 20.3204742,10.4250656 L18.0236906,12.8159548 L17.0873096,13.790702 C16.7162907,14.1769225 16.1862637,14.4160114 15.6562368,14.4160114 L11.0980048,14.4160114 C10.6916508,14.4160114 10.3382994,14.0849652 10.3206319,13.6619618 C10.3029643,13.2021754 10.6563156,12.8343463 11.0803372,12.8343463 L15.7092395,12.8343463 C16.6456205,12.8343463 17.4583285,12.135471 17.6173366,11.1791153 C17.6526717,10.9584178 17.6703393,10.7377204 17.6703393,10.4986314 C17.6703393,10.0572365 17.3346555,9.70779885 16.9106339,9.70779885 L14.3665045,9.70779885 C13.5361289,9.70779885 12.7410884,9.32157829 11.8930452,8.89857481 C11.0096669,8.45717988 10.0909535,8.01578495 9.03089956,7.94221913 C8.09451857,7.86865331 7.15813758,7.97900204 6.23942415,8.25487387 C5.26770803,8.54913716 4.5610054,9.45031848 4.47266757,10.4986314 C4.47266757,10.4986314 4.47266757,10.4986314 4.455,10.4986314 L4.455,18.315 L17.6173366,18.315 C18.5183824,18.315 19.3664256,17.9471709 20.0201255,17.2850785 L25.5147385,11.5653359 C25.8150872,11.2342897 25.8150872,10.7377204 25.5147385,10.4250656 L25.5147385,10.4250656 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteLoans);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-loans.aeaacec35d32a7a1c84b9f34a0945021.svg";